module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp12_7.414f30c2.png";